export default {
  methods: {
    getInputsTestLocalStorage() {
     return JSON.parse(localStorage.getItem("idt-inputs-test-processor")) || null
    },
    getItemTestLocalStorage(item) {
      return this.getInputsTestLocalStorage() && this.getInputsTestLocalStorage()[item] ? this.getInputsTestLocalStorage()[item] : ''
    },
    getInputsTransformLocalStorage() {
      let inputTest = this.getInputsTestLocalStorage()
      let inputTransform = JSON.parse(localStorage.getItem("idt-inputs-transform-processor"))

      if(inputTransform){
        return inputTransform
      } else if(inputTest) {
        return {
          schema: inputTest.schema || '',
          options: inputTest.options || ''
        }
      } else {
        return null
      }
    },
    getItemLocalStorage(key){
      return JSON.parse(localStorage.getItem(key)) || null
    },
    setItemLocalStorage(key, value){
      localStorage.setItem(key, JSON.stringify(value))
    }
  }
};
